import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Divider,
  Form,
  Input,
  Row,
  Col,
  Select,
  DatePicker,
} from "antd";

import util from "../../utils/functions/custom";
import { Messages, Notify } from "../../services/custom/Messages";
import moment from 'moment';
import {openNotification, progressIndicatorEnum} from "@seims/shared";


import lookupAPI from "../../services/candidateLookupService";
import api from "../../services/nysService";
import { getProfile } from "../../security/AppSecurity";
import { recordError } from "../../utils/logService";

const QualificationView = ({ onProgressUpdate, data, readOnly }) => {
  const [userData, setUserData] = useState(getProfile());
  const [qualifications, setQualifications] = useState([]);
  const [qualificationData, setQualificationData] = useState({});

  const formItemLayout = {
    labelCol: {
      span: 12,
    },
    wrapperCol: {
      span: 18,
    },
    layout: "vertical",
  };

  const { Option } = Select;
  const [form] = Form.useForm();
  const formName = "QualificationForm";

  // useEffect(() => {
  //   //getQualifications();
  // }, []);

  useEffect(() => {
    prePopilateQualifs();
  }, [qualificationData, data]);

  const onNameBlur = (e) => {
    const { value, name } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [name]: textValue });
  };

  const prePopilateQualifs = ()=> {
    try {
      
      if (!util.isEmpty(data)) {
        
        form.setFieldsValue({
          id: data.id,
          fieldOfStudy: data.fieldOfStudy,
          highestQualification: data.highestQualification,
          institutionOfStudy: data.institutionOfStudy,
          grade12CompletionYear: moment(data.grade12CompletionYear, "YYYY"),

          //!SUBJECTS SHOULD BE MANAGED LIKE CONTRIBUTIONS
          //!ONE SHOULD HAVE OT LOOP THE ARRAYS AND MAP TO CONRRESPONDING CONTROL
          subject1: data.subjects.length > 0 ? data.subjects[0] : "",
          subject2: data.subjects.length > 1 ? data.subjects[1] : "",
          subject3: data.subjects.length > 2 ? data.subjects[2] : ""
        });
        setQualificationData(data);
        
      }
    } catch (error) {
      recordError(error);
      // console.log("ERROR", error);
    }
  }

  const getQualifications = async () => {
    try {
      const response = await lookupAPI.getQualifications();
      if (response) {
        const { data } = response;
        setQualifications(data);
      }
    } catch (error) {
      // console.log("ERROR", error);
    }
  };

  const onQualificationChange = (selected) => {
    const qualificationSelected = qualifications.find(
      (record) => record.key == selected
    );
    form.setFieldsValue({ highestQualification: qualificationSelected });
  };

  const clearFormContents = () => {
    form.resetFields();
  };
  const onSubmit = async (values) => {
    try {

      const candidateYear = moment(values.grade12CompletionYear).format("YYYY");
      values.grade12CompletionYear = candidateYear;
      const user = getProfile();

      
      const {
        highestQualification,
        fieldOfStudy,
        institutionOfStudy,
        subject1,
        subject2,
        subject3,
      } = values;
      
      const subjects = [subject1, subject2, subject3];
      const qualifications = {
        id: qualificationData?.id > 0 ? qualificationData.id : "-1",
        highestQualification: highestQualification.key,
        fieldOfStudy: fieldOfStudy,
        institutionOfStudy: institutionOfStudy,
        subjects: subjects,
        grade12CompletionYear: candidateYear,
        userId: user.userId,
      };
      
      onProgressUpdate(progressIndicatorEnum.IN_PROGRESS);

      const request = await api.addQualifications(qualifications);
      var msg;
      
      if (request && (request.status == 200 || request.status == 201)) {
        onProgressUpdate(progressIndicatorEnum.COMPLETED);
        msg = util.parseMessage(Messages.ADD_SUCCESS, "Qualification detail(s)");
        openNotification("Save qualification", msg, Notify.SUCCESS);
        return;
      }

      msg = util.parseMessage(Messages.ADD_FAILURE, "Qualification detail(s)");
      openNotification("Save qualification", msg, Notify.ERROR);


    } catch (error) {
      onProgressUpdate(progressIndicatorEnum.NOT_STARTED);
      recordError(error);
      // console.log("QUALIFICATION FAILED TO SAVE", error);
      openNotification("Adding qualification", "SYSTEM FAILED TO SAVE", Notify.ERROR);
    }
  };

  return (
    <>
      {/* <PageHeader
        title="Highest Qualifications"
        subTitle="Specify your highest qualification"
      ></PageHeader>
      <Divider /> */}
      <h1 className="center-align">Highest Qualification</h1>
      <p className="sub-title center-align">Specify your highest qualification</p>
      <br/>
      <Form {...formItemLayout} name={formName} form={form} onFinish={onSubmit}  
      labelCol={{
        span: 24,
      }}
      disabled={readOnly}
      >
        <Row>
          <Col xs={24} sm={8} md={7}>
            <Form.Item
              name="highestQualification"
              label="Qualification"
              rules={[
                {
                  required: true,
                  message: "Please select your highest qualification",
                },
              ]}
            >
              <Input name="highestQualification" disabled onBlur={onNameBlur} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8} md={7}>
            <Form.Item
              name="fieldOfStudy"
              label="Field of Study"
              rules={[
                { required: true, message: "Please enter your field of study" },
              ]}
            >
              <Input name="fieldOfStudy" onBlur={onNameBlur} disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8} md={7}>
            <Form.Item
              name="institutionOfStudy"
              label="Institution of Study"
              rules={[
                {
                  required: true,
                  message: "Please enter your institution of study",
                },
              ]}
            >
              <Input name="institutionOfStudy" onBlur={onNameBlur} disabled/>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <p>Major Subjects (Max 3)</p>
        </Row>
        <Row>
          <Col xs={24} sm={8} md={7}>
            <Form.Item
              name="subject1"
              label="Subject 1"
              rules={[
                {
                  required: true,
                  message: "Please enter at least one subject",
                },
              ]}
            >
              <Input name="subject1" onBlur={onNameBlur} disabled/>
            </Form.Item>
          </Col>
          <Col xs={24} sm={8} md={7}>
            <Form.Item name="subject2" label="Subject 2">
              <Input name="subject2"  onBlur={onNameBlur} disabled/>
            </Form.Item>
          </Col>
          <Col xs={24} sm={8} md={7}>
            <Form.Item name="subject3" label="Subject 3">
              <Input name="subject3" onBlur={onNameBlur} disabled/>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={20}>
            <Form.Item
              name="grade12CompletionYear"
              label="Year Grade 12 obtained"
              rules={[
                {
                  required: true,
                  message: "Please select grade 12 completion year",
                },
              ]}
            >
              <DatePicker picker="year" disabled/>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            {false &&
            <Button key="2" htmlType="submit" form={formName} shape="round" type="primary" className="right-align-button">
            Save Highest Qualification
            </Button>}
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default QualificationView;
